import "../scss/styles.scss";

jQuery(($) => {
  /****************** HAMBURGERS MENU ******************/

  $("#header").on("click", "button.navbar-toggler", function () {
    $(this).toggleClass("is-active");
    $("main#main").toggleClass("is--open");
    $("nav#header").toggleClass("menu-open");
    $("body").toggleClass("is--open");
  });

  /****************** ACCORDIONS ******************/

  $(".accord:has(div ul li.active)").addClass("active");

  $(".accord .header").on("click", function () {
    $(this).parent().toggleClass("active");
    $(this).siblings().toggleClass("spacing");
  });

  $(".accord .answer").on("click", function () {
    $(this).parent().toggleClass("active");
    $(this).toggleClass("spacing");
  });
});

$.fn.isInViewport = function () {
  const elementTop = $(this).offset().top;
  const elementBottom = elementTop + $(this).outerHeight();

  const viewportTop = $(window).scrollTop();
  const viewportBottom = viewportTop + $(window).height();

  return elementBottom > viewportTop && elementTop < viewportBottom;
};
